import { Link } from "react-router-dom";
import styles from "./styles.module.scss";

interface Alert {
  id: number;
  cta: {
    enabled: boolean;
    url: string;
    label: string;
  };
  severity: "INFO" | "WARNING" | "CRITICAL";
  createdAt: string;
  updatedAt: string;
  messageAr: string;
  descriptionAr?: string;
  surfaces: Array<"ANDROID" | "IOS" | "WEB">;
  status: "ACTIVE" | "INACTIVE";
}
interface AlertWidgetProps {
  activeAlertWidget: Alert;
}
enum AlertSeverityType {
  INFO = "INFO",
  WARNING = "WARNING",
  CRITICAL = "CRITICAL",
}

const AlertWidget = ({ activeAlertWidget }: AlertWidgetProps) => {
  const alertSeverityType: AlertSeverityType =
    activeAlertWidget?.severity as AlertSeverityType;

  const alertWidgetIcon = () => {
    switch (alertSeverityType) {
      case AlertSeverityType.INFO:
        return "/assets/images/svg/alertInfo.svg";
      case AlertSeverityType.WARNING:
        return "/assets/images/svg/alertWarning.svg";
      case AlertSeverityType.CRITICAL:
        return "/assets/images/svg/alertCritical.svg";
    }
  };

  const alertWidgetText = activeAlertWidget?.messageAr;
  const alertWidgetDescription = activeAlertWidget?.descriptionAr;
  const ctaEnabled = activeAlertWidget?.cta?.enabled;
  const alertWidgetCtaLabel = activeAlertWidget?.cta?.label;
  const alertWidgetCtaUrl = activeAlertWidget?.cta?.url ?? "";

  if (!activeAlertWidget) {
    return null;
  }

  return (
    <div className={styles.alert_widget} data-severity={alertSeverityType}>
      <img
        className={styles.alert_widget_icon}
        src={alertWidgetIcon()}
        alt="alert-icon"
      />
      <div className={styles.alert_widget_content}>
        <p className={styles.alert_widget_text}>{alertWidgetText}</p>
        {!!alertWidgetDescription && (
          <p className={styles.alert_widget_description}>
            {alertWidgetDescription}
          </p>
        )}
        {ctaEnabled && alertWidgetCtaLabel && (
          <Link className={styles.alert_widget_link} to={alertWidgetCtaUrl}>
            {alertWidgetCtaLabel}
          </Link>
        )}
      </div>
    </div>
  );
};

export default AlertWidget;
